if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.content = this.querySelector('[role="document"]');
        this.previousButton = this.querySelector('[data-media-previous]');
        this.nextButton = this.querySelector('[data-media-next]');
        this.currentCounter = this.querySelector('[data-media-current]');
        this.totalCounter = this.querySelector('[data-media-total]');

        [this.querySelector('[id^="ModalClose-"]'), this.previousButton, this.nextButton].forEach((button) => {
          button?.addEventListener('pointerup', (event) => event.stopPropagation());
        });

        this.previousButton?.addEventListener('click', () => this.changeMedia(-1));
        this.nextButton?.addEventListener('click', () => this.changeMedia(1));
        this.addEventListener('keydown', (event) => this.handleKeyboardNavigation(event));
        this.content?.addEventListener('pointerdown', (event) => this.startSwipe(event));
        this.content?.addEventListener('pointerup', (event) => this.endSwipe(event));
      }

      hide() {
        if (!this.hasAttribute('open')) return;

        const opener = this.openedBy;
        const scrollPosition = this.pageScrollPosition;
        this.openedBy = null;
        super.hide();
        this.openedBy = opener;
        opener?.focus({ preventScroll: true });

        if (scrollPosition) {
          window.scrollTo(scrollPosition.left, scrollPosition.top);
        }

        this.pageScrollPosition = null;
      }

      show(opener) {
        this.pageScrollPosition = {
          left: window.scrollX,
          top: window.scrollY,
        };
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.mediaItems = this.content
          ? Array.from(this.content.children).filter((element) => element.hasAttribute('data-media-id'))
          : [];
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const activeIndex = this.mediaItems.findIndex((element) => element.dataset.mediaId === mediaId);

        if (!this.content || activeIndex < 0) return;

        this.activateMedia(activeIndex);
      }

      activateMedia(index) {
        if (!this.mediaItems?.length) return;

        this.activeMediaIndex = (index + this.mediaItems.length) % this.mediaItems.length;
        const activeMedia = this.mediaItems[this.activeMediaIndex];

        this.mediaItems.forEach((element) => {
          element.classList.remove('active');
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        this.content.scrollTop = 0;
        this.content.scrollLeft = Math.max(0, (activeMedia.scrollWidth - this.content.clientWidth) / 2);
        this.updateNavigation();
        window.pauseAllMedia();

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      changeMedia(direction) {
        this.activateMedia(this.activeMediaIndex + direction);
      }

      updateNavigation() {
        const hasMultipleMedia = this.mediaItems.length > 1;

        this.previousButton.hidden = !hasMultipleMedia;
        this.nextButton.hidden = !hasMultipleMedia;
        this.currentCounter.parentElement.hidden = !hasMultipleMedia;
        this.currentCounter.textContent = this.activeMediaIndex + 1;
        this.totalCounter.textContent = this.mediaItems.length;
      }

      handleKeyboardNavigation(event) {
        if (!this.hasAttribute('open')) return;
        if (event.target.matches('input, select, textarea')) return;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.changeMedia(-1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.changeMedia(1);
        }
      }

      startSwipe(event) {
        if (event.pointerType !== 'touch') return;

        this.swipeStart = { x: event.clientX, y: event.clientY };
      }

      endSwipe(event) {
        if (event.pointerType !== 'touch' || !this.swipeStart) return;

        event.stopPropagation();
        const horizontalDistance = event.clientX - this.swipeStart.x;
        const verticalDistance = event.clientY - this.swipeStart.y;
        this.swipeStart = null;

        if (Math.abs(horizontalDistance) < 50 || Math.abs(horizontalDistance) <= Math.abs(verticalDistance)) return;

        this.changeMedia(horizontalDistance < 0 ? 1 : -1);
      }
    }
  );
}
